import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCONSELHOChartsDataContext } from './hooks/useIDCONSELHOChartsDataContext';

export const PopulationEvolutionChart = () => {
    const { chartData } = useIDCONSELHOChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual da População"
            subtitles={chartData.population.map((item) => getYearLabel(item.ano))}
            values={chartData.population.map(
                (item) => Number(item.populacao) || 0
            )}
        />
    );
};
